
var Model = require("../types/Model.js");
var UserMetricsUtils = require("../../utils/UserMetricsUtils");

module.exports = Model({
	name: "preferences",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	_new_email: null,
});

function init() {
	this.push({
		_id: "",
		apartment: "",
		available: "",
		city: "",
		confirm_email: "",
		confirm_password: "",
		country: "",
		dob: "",
		email: "",
		fname: "",
		gender: "",
		image: "",
		language: "",
		layout: "",
		lname: "",
		months: [],
		new_password: "",
		old_password: "",
		org: "",
		phone: "",
		postal: "",
		province: "",
		ringtone: "",
		searchHidden: false,
		street: "",
		type: "",
		autologout: false,
		multifactor: false,
		defaultContactSettings: {}
	});
}

function uninit() {
	this._new_email = null;
}

function listeners() {
	return {
		"personal:updated": handle_personal_updated,
	};
}

function triggers() {
	return {
		"view": handle_trigger_view,
		"preferences:update": handle_trigger_preferences_updated,
		"preferences:update:contactSettings": handle_trigger_contact_settings_update,
		"preferences:update:email": handle_trigger_email_update,
		"preferences:update:password": handle_trigger_password_update,
	};
}

function handle_trigger_view() {
	this.emit("autoreply:trigger:view");
	this.emit("schedules:trigger:view");
	this.dispatch("viewing");
	this.emit("usermetrics:trigger:track", "view own account menu");
}

function handle_personal_updated(data) {
	this.extend(data);
}

function handle_trigger_preferences_updated(data) {
	this.emit("save:trigger:start");
	const diff = UserMetricsUtils.difference(data, this.data, ["updated_at", "token"]);
	const update_fields = Object.keys(diff);

	if(data.dob)
		var dob = (new Date(data.dob)).toISOString();

	data.dob = dob;

	this.api.people.update(data)
		.then(handle_preferences_update_success.bind(this))
		.catch(handle_preferences_update_error.bind(this));

	if (!data._id) {
		data.language && this.emit("usermetrics:trigger:track", "update own language", { 
			language: data.language
		});
		data.ringtone && this.emit("usermetrics:trigger:track", "update own ringtone", {
			ringtone: data.ringtone
		});
	} else {
		this.emit("usermetrics:trigger:track", "update own personal information or account preferences", {
			update_fields
		});
	}
}

function handle_preferences_update_error(error) {
	var code = error.status;
	var message = "myprofile.networkerror";

	if (code === 0) {
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
	}
	this.emit("save:trigger:finish");
}

function handle_preferences_update_success() {
	this.emit("save:trigger:finish");
	var message = "myprofile.infosuccess";
	this.emit("toast:trigger:show", {
		content: message
	});

}

function handle_trigger_email_update(data) {
	var current_email = this.data.email;
	this._new_email = data.new_email;
	var confirm_email = data.confirm_email;
	var errorMessage = "";

	if (!(this._new_email) || !(confirm_email)){
		errorMessage = "myprofile.emailmissingfields";
	}
	else if (this._new_email !== confirm_email) {
		errorMessage = "myprofile.emailmismatch";
	}
	else if (this._new_email === current_email) {
		errorMessage = "myprofile.emailSame";
	}

	if(errorMessage){
		this.emit("toast:trigger:show", {
			content: errorMessage,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to update own email but encountered errors", {
			error: errorMessage
		});
		return;
	}

	this.emit("save:trigger:start");

	this.api.auth.email({
		email: this._new_email,
		confirm: confirm_email
	})
		.then(handle_preferences_update_email_success.bind(this))
		.catch(handle_preferences_update_email_error.bind(this));

	this.emit("usermetrics:trigger:track", "update own email");
}

function handle_preferences_update_email_success() {
	this.extend({
		email: this._new_email,
		confirm_email: "",
	});
	this.emit("save:trigger:finish");
	var message = "myprofile.emailupdatesuccess";
	this.emit("toast:trigger:show", {
		content: message
	});
}

function handle_preferences_update_email_error(error) {
	this.emit("save:trigger:finish");

	var code = error.status;
	var errorMessage = "";
	if (code === 0) {
		errorMessage = "myprofile.networkerror";
	} else if (code === 402) {
		errorMessage = "myprofile.emailalreadytaken";
	}

	if(errorMessage){
		this.emit("toast:trigger:show", {
			content: errorMessage,
			style: "error"
		});
	}
}

function handle_trigger_password_update(data) {
	var old_password = data.old_password;
	var new_password = data.new_password;
	var confirm_password = data.confirm_password;
	var message = "";
	var account_info = data.account_info;
	var fname = account_info.fname;
	var lname = account_info.lname;
	var email = account_info.email;

	if (!old_password || !new_password || !confirm_password){
		message = "myprofile.passwordmissingfields";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to update own password but did not fill all fields");
		return;
	}

	if (new_password === old_password){
		message = "myprofile.passworddifferent";
		this.emit("toast:trigger:show", {
			content: message,
			style: "error"
		});
		this.emit("usermetrics:trigger:track", "attempt to update own password but did passwords did not match");
		return;
	}

	var emailArr = email.split("@");
	var emailStr = emailArr[0];
	if (new_password.includes(fname) || new_password.includes(lname) || new_password.includes(emailStr)) {
		this.emit("usermetrics:trigger:track", "attempt to update own password but did password included name or email");
		return this.emit("toast:trigger:show", {
			content: "myprofile.invalidnameinclusion",
			style: "error"
		});
	}

	this.emit("save:trigger:start");

	this.api.auth.password({
		password: new_password,
		old: old_password,
		confirm: confirm_password
	})
		.then(handle_preferences_update_password_success.bind(this))
		.catch(handle_preferences_update_password_error.bind(this));

	this.emit("usermetrics:trigger:track", "update own password");
}

function handle_preferences_update_password_success() {
	this.extend({
		old_password: "",
		new_password: "",
		confirm_password: "",
	});
	this.emit("save:trigger:finish");
	var message = "myprofile.passwordsuccess";
	this.emit("toast:trigger:show", {
		content: message
	});
}

function handle_preferences_update_password_error(error) {
	var code = error.status;
	var response = error.response;

	if (code === 0) {
		this.emit("toast:trigger:show", {
			content: "myprofile.networkerror",
			style: "error"
		});
	}
	if (code === 401) {
		this.emit("toast:trigger:show", {
			content: "myprofile.error401",
			style: "error"
		});
	}
	if(code === 400){
		var toast = "myprofile.invalidpassword";
		if(response.message === "Password must not include 2 sequential characters from keyboard")
			toast = "myprofile.invalidsequential";
		else if (response.message === "Password must not include 3 consecutive characters")
			toast = "myprofile.invalidconescutive";
		else if (response.message === "Password does not match basic rules")
			toast = "myprofile.invalidbasicrules";
		else if (response.message === "Pasword confirm doesn't match")
			toast = "register.passwordmismatch";
		else if (response.message === "Password must not be one of your 5 previously used passwords")
			toast = "myprofile.invalidpreviouslyused";
		this.emit("toast:trigger:show", {
			content: toast,
			style: "error"
		});
	}
	this.emit("save:trigger:finish");
}

function handle_trigger_contact_settings_update(data){
	var update = {
		defaultContactSettings: data
	};

	this.emit("usermetrics:trigger:track", "update own default contact settings");

	return this.api.people.update(update)
		.then(handle_preferences_update_success.bind(this))
		.catch(handle_preferences_update_error.bind(this));
}
